import { OperatorSystemUsagePage } from "@/components/system-usage/operator-system-usage-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/system-usage/")({
  validateSearch: (search: Record<string, unknown>) => ({
    from: typeof search.from === "string" ? search.from : undefined,
    to: typeof search.to === "string" ? search.to : undefined,
  }),
  component: SystemUsageComparisonRoute,
});

function SystemUsageComparisonRoute() {
  const { from, to } = Route.useSearch();
  return <OperatorSystemUsagePage initialFrom={from} initialTo={to} />;
}
